<template>
  <div>
    <el-row class="demo-avatar demo-basic" type="flex" justify="center">
      <el-col :span="23">
        <div class="profile_head_zone mt-10">
          <div class="block"><el-avatar :size="80" :src="circleUrl"></el-avatar></div>
          <span class="avatar_first_name">{{ user.lastName }}</span><br/>
          <span class="avatar_first_name">{{ user.phone1 }}</span><br/>
        </div>
        <div class="profile_zone mt-10">
          <span class="avatar_email mt-20 ml-3">Тоон үзүүлэлтүүд</span>
          <el-card class="w-100 mt-5">
              <span>Таны бүртгэсэн бараа:</span>
              <span class="flr">{{ total }}</span>
          </el-card>
          <el-card class="w-100 mt-3">
              <span>Таны хүлээлгэн өгсөн бараа:</span>
              <span class="flr">{{ totalSuccess }}</span>
          </el-card>
        </div>
        <div class="mt-10" style="margin-bottom: 5px">
          <el-button class="w-100 mb-3" type="warning" @click="openCostDialog('porter')">Зардал - портер</el-button>
        <div style="margin-top: 5px">
          <el-button class="w-100 mb-3" type="info" @click="openCostDialog('flow')">Урсгал зардал</el-button>
        </div>
        <div style="margin-top: 5px">
            <el-button class="w-100 mb-3" type="primary" @click="openCostDialog('transfer')">Салбар хооронд шилжүүлэлт</el-button>
          </div>
          <div style="margin-top: 5px">
            <el-button class="w-100 mb-3" type="danger" @click="logout()">Гарах</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <CostListDialog
      :visible="costDialogVisible"
      :costType="selectedCostType"
      @close="closeCostDialog"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import services from '@/helpers/services'
import CostListDialog from '@/views/Dialog/CostListDialog.vue'

export default {
  name: 'ProfilePage',
  components: {
    CostListDialog
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  data () {
    return {
      circleUrl: 'https://i.pinimg.com/474x/0f/e0/0f/0fe00f0759660c97dc4668cae473378e.jpg',
      squareUrl: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      sizeList: ['large', 'medium', 'small'],
      total: null,
      totalSuccess: null,
      costDialogVisible: false,
      selectedCostType: null
    }
  },
  created () {
    this.getCountData()
  },
  methods: {
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    },
    getCountData () {
      services.getTrackCodeCountByUser()
        .then((response) => {
          this.total = response.total
          this.totalSuccess = response.totalSuccess
        })
        .catch((error) => {
          console.error('Aldaa:', error)
        })
    },
    openCostDialog (type) {
      this.selectedCostType = type
      this.costDialogVisible = true
    },
    closeCostDialog () {
      this.costDialogVisible = false
      this.selectedCostType = null
    }
  }
}
</script>
<style>
.demo-avatar{
    justify-items: center;
}
.avatar_first_name{
    font-family: 'Geologica', sans-serif;
    font-weight: 400;
    font-size: 20px;
}
.avatar_email{
    font-weight: 200;
}
.profile_head_zone{
    text-align: center;
}
.profile_zone{
}
</style>
